import type { Locale } from '@/lib/i18n/config'
import { getMessages } from '@/lib/i18n/messages'
import type { LocationPage } from '@/lib/mock/locationPages'

const LOCATION_PAGE_SLUG_ALIASES: Record<string, string> = {
  tu3: 'tuebingen',
}

export function getLocationPageCopy(slug: string, locale: Locale) {
  const pages = getMessages(locale).location.pages
  const pageSlug = LOCATION_PAGE_SLUG_ALIASES[slug] ?? slug
  if (pageSlug in pages) {
    return pages[pageSlug as keyof typeof pages]
  }

  return undefined
}

export function getLocationHoverDescription(slug: string, locale: Locale, fallback = '') {
  const copy = getLocationPageCopy(slug, locale)?.description ?? fallback
  return splitLocationDescription(copy)[0]
}

export function splitLocationDescription(description: string): string[] {
  return description
    .split(/\n\n+/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
}

export function applyLocationPageCopy(location: LocationPage, locale: Locale): LocationPage {
  const copy = getLocationPageCopy(location.slug, locale)
  if (!copy) {
    return location
  }

  const hasDescription = Boolean(copy.description)
  const hasAreaMapCopy =
    Boolean(copy.areaMapTitleBeforeHighlight) ||
    Boolean(copy.areaMapTitleHighlight) ||
    Boolean(copy.areaMapCtaLabel)

  if (!hasDescription && !hasAreaMapCopy) {
    return location
  }

  return {
    ...location,
    ...(hasDescription ? { description: copy.description } : {}),
    ...(hasAreaMapCopy
      ? {
          areaMap: {
            ...location.areaMap,
            ...(copy.areaMapTitleBeforeHighlight
              ? { titleBeforeHighlight: copy.areaMapTitleBeforeHighlight }
              : {}),
            ...(copy.areaMapTitleHighlight
              ? { titleHighlight: copy.areaMapTitleHighlight }
              : {}),
            ...(copy.areaMapCtaLabel ? { ctaLabel: copy.areaMapCtaLabel } : {}),
          },
        }
      : {}),
  }
}
